<script setup>
// O painel ao lado do trilho: os itens do módulo aberto (em Conversas, os
// filtros, caixas, times e etiquetas). Grupos usam o SidebarSubGroup do core,
// com o mesmo recolher, ordenar e contagem de não lidas.
import Icon from 'next/icon/Icon.vue';
import SidebarSubGroup from 'dashboard/components-next/sidebar/SidebarSubGroup.vue';
import SidebarUnreadBadge from 'dashboard/components-next/sidebar/SidebarUnreadBadge.vue';

defineProps({
  modulo: { type: Object, required: true },
  ativo: { type: Object, default: undefined },
});

const emit = defineEmits(['navegou']);
</script>

<template>
  <ul class="grid gap-0.5 m-0 list-none min-w-0">
    <template v-for="item in modulo.children" :key="item.name">
      <SidebarSubGroup
        v-if="item.children"
        :name="`${modulo.name}:${item.name}`"
        :label="item.label"
        :icon="item.icon"
        :children="item.children"
        :collapsible="item.collapsible"
        :show-tree-line="item.showTreeLine"
        :sort-options="item.sortOptions"
        :active-sort="item.activeSort"
        is-expanded
        :active-child="ativo"
        class="mt-2"
        @update-sort="item.onSortChange"
      />
      <li v-else class="min-w-0">
        <router-link
          :to="item.to"
          :title="item.label"
          class="flex items-center gap-2 h-8 px-2 rounded-lg text-sm min-w-0 transition-colors duration-100"
          :class="
            ativo?.name === item.name
              ? item.destaque
                ? 'bg-[#f08820]/10 text-[#b45f0c] dark:bg-[#f08820]/15 dark:text-[#f5a650] font-medium'
                : 'bg-n-alpha-2 text-n-slate-12 font-medium'
              : 'text-n-slate-11 hover:bg-n-alpha-1'
          "
          @click="emit('navegou')"
        >
          <Icon v-if="item.icon" :icon="item.icon" class="size-4 shrink-0" />
          <span class="flex-1 truncate">{{ item.label }}</span>
          <span
            v-if="item.destaque && item.badgeCount"
            class="min-w-5 h-5 px-1.5 grid place-content-center rounded-full text-xs font-medium bg-[#f08820] text-white"
          >
            {{ item.badgeCount }}
          </span>
          <SidebarUnreadBadge v-else :count="item.badgeCount" />
        </router-link>
      </li>
    </template>
  </ul>
</template>
